export default __webpack_public_path__ + "2f50a55646b1a0414420bdf9dffa0a0b.png";